import moment, { Moment } from "moment";

export const getMomentTimeFromUTC = (input?: moment.MomentInput, format?: moment.MomentFormatSpecification) => {
        if (format)
                return moment(input, format).utcOffset(getTimeZoneOffset() + moment().utcOffset() / 60);
        if (input)
                return moment(input).utcOffset(getTimeZoneOffset() + moment().utcOffset() / 60)
        return moment().utcOffset(getTimeZoneOffset());
}

export const getMomentTimeToUTC = (input?: moment.MomentInput, format?: moment.MomentFormatSpecification) => {
        console.log(input)
        console.log()
        if (format)
                return moment(input, format).utcOffset(moment().utcOffset() / 60 - getTimeZoneOffset());
        return moment(input).utcOffset(moment().utcOffset() / 60 - getTimeZoneOffset());
 
}

export const getTimeZoneOffset = () => {
        return parseInt(localStorage.getItem('timezone') || '3');
}